<!--
 * @Author: your name
 * @Date: 2022-01-04 17:39:57
 * @LastEditTime: 2022-03-01 16:20:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\views\dashboard\Analysis.vue
-->
<template>
  <div>
    <index-chart v-if="indexStyle == 1"></index-chart>
    <index-bdc v-if="indexStyle == 2"></index-bdc>
    <index-task v-if="indexStyle == 3"></index-task>
    <div style="width: 100%;text-align: right;margin-top: 20px">
      请选择首页样式：
      <a-radio-group v-model="indexStyle">
        <a-radio :value="1">统计图表</a-radio>
        <a-radio :value="2">统计图表2</a-radio>
        <a-radio :value="3">任务表格</a-radio>
      </a-radio-group>
    </div>
  </div>
</template>

<script>
import IndexChart from './IndexChart'
import IndexTask from './IndexTask'
import IndexBdc from './IndexBdc'

export default {
  name: 'Analysis',
  components: {
    IndexChart,
    IndexTask,
    IndexBdc
  },
  data() {
    return {
      indexStyle: 1
    }
  },
  created() {},
  methods: {}
}
</script>
